export const DocumentAtvCrStatusLabelComponent = {
  template: `<span class="status-label text-{{ vm.statusClass }}">
            <i class="fa fa-circle" ng-if="vm.status"></i> {{ vm.statusTitle }}</span>`,
  bindings: {
    status: '<',
  },
  controller: DocumentAtvCrStatusLabelController,
  controllerAs: 'vm',
};

DocumentAtvCrStatusLabelController.$inject = ['$translate'];

function DocumentAtvCrStatusLabelController($translate) {
  const vm = this;

  vm.$onChanges = function () {
    setStatusLabel();
  };

  function setStatusLabel() {
    let statusClass = '';
    let statusIcon = '';
    let statusTitle = '-';

    if (vm.status) {
      switch (vm.status) {
        case 'accepted':
          statusClass = 'success';
          statusIcon = 'check';
          statusTitle = 'ACCEPTED';
          break;
        case 'rejected':
          statusClass = 'danger';
          statusIcon = 'ban';
          statusTitle = 'REJECTED';
          break;
        case 'fail':
          statusClass = 'danger';
          statusIcon = 'exclamation-triangle';
          statusTitle = 'FAILED';
          break;
        default:
          statusClass = 'primary';
          statusIcon = 'spinner';
          statusTitle = 'PENDING';
          break;
      }
    }

    vm.statusClass = statusClass;
    vm.statusIcon = statusIcon;
    vm.statusTitle = $translate.instant(statusTitle);
  }
}
